'use client';

import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Spin } from '@/components/ui-feat/spin';
import cn from 'clsx';

interface PlaceholderProps {
  className?: string;
}

export default function Placeholder({ className = '' }: PlaceholderProps) {

  return (
    <div className={cn('px-[12px] py-[16px]', className)}>
      <div className="flex flex-col space-y-2">
        <Spin className="h-44 w-full rounded-lg" />
        <div className="space-y-1">
          <Skeleton className="h-4 w-1/4" />
        </div>
        <div className="flex gap-2">
          <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
          <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
          <Skeleton className="h-44 w-1/5 rounded-lg" />
        </div>
        <div className="flex gap-2">
          <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
          <Spin className="h-44 w-2/5 rounded-lg" logoWidth={42} logoHeight={30} />
          <Skeleton className="h-44 w-1/5 rounded-lg" />
        </div>
        <div className="space-y-1">
          <Skeleton className="h-4 w-1/4" />
        </div>
        <div className="flex gap-2">
          <Spin className="h-36 w-full rounded-lg" />
        </div>
      </div>
    </div>
  );
}
